import { NO_COMPARISON, variation } from "../../utils/analyticsDeltas";
import { percentOf } from "../../utils/analyticsSeries";
import { formatCount, formatFixed, formatPercent } from "../charts/format";

// Os numeros de faixa que aparecem em mais de um separador, feitos num so sitio para dizerem o mesmo em
// todos: a taxa de abertura (visao geral e Adocao) e as conversas iniciadas por uma sugestao (visao geral,
// Conversas e Conteudo). Cada um recebe o resumo, o `previousComplete` da pagina, o translate e a lingua,
// e devolve o numero na forma que o KpiStrip desenha.

// "N coisas", com o singular a parte: o {plural} das traducoes so junta um "s" ("1 aberturas"), e uma
// pergunta escrita, um dia calmo ou um chat pequeno dao muitas vezes 1. `key` e a chave do plural, com
// `{count}`, e `${key}One` a do singular.
export const countText = (value, key, translate, language) =>
  value === 1 ? translate(`${key}One`) : translate(key, { count: formatCount(value, language) });

// A media por dia com uma casa entre 0 e 10 (um chat calmo dizia "0 por dia"); zero e "0", nao "0.0", e
// abaixo de 0,05, que a casa arredondava para "0.0" e se lia como nenhuma, e "menos de 0,1".
export const perDayText = (total, days, translate, language) => {
  const perDay = total / days;
  if (perDay === 0) return formatCount(0, language);
  if (perDay < 0.05) return translate("analyticsLessThan", { value: formatFixed(0.1, 1, language) });
  return perDay < 10 ? formatFixed(perDay, 1, language) : formatCount(perDay, language);
};

// O contexto de uma contagem da faixa: o anterior e a media por dia. Num periodo de um dia (a serie vem por
// hora) a media por dia sai (item 12, D14); um resumo sem `granularity` le-se por dia (D15).
export const previousAndPerDayText = ({ previous, total, series, translate, language }) =>
  series.granularity === "hour"
    ? translate("analyticsKpiPrevious", { previous: formatCount(previous, language) })
    : translate("analyticsKpiPreviousAndPerDay", {
        previous: formatCount(previous, language),
        perDay: perDayText(total, series.buckets.length, translate, language),
      });

// O backend manda a taxa de abertura por 1000 visualizacoes; mostra-se em percentagem, com duas casas.
const openRatePercent = (value) => (value === null ? null : value / 10);

export const openRateKpi = ({ summary, previousComplete, translate, language }) => {
  const { headline, funnel } = summary;
  const m = summary.series.metrics;
  const rate = headline.opens_per_1000_page_views;
  return {
    key: "open_rate",
    label: translate("analyticsOpenRate"),
    value: rate.value === null ? translate("analyticsNotAvailable") : `${formatFixed(openRatePercent(rate.value), 2, language)}%`,
    change: previousComplete
      ? variation({ kind: "percent", value: openRatePercent(rate.value), previous: openRatePercent(rate.previous), digits: 2 }, language)
      : NO_COMPARISON,
    spark: [percentOf(m.opens.current, m.page_views.current), percentOf(m.opens.previous, m.page_views.previous)],
    context: translate("analyticsKpiOpenRateContext", {
      opens: countText(funnel.opens, "analyticsKpiOpenCount", translate, language),
      views: countText(headline.page_views.value, "analyticsKpiPageViewCount", translate, language),
    }),
  };
};

export const startedWithSuggestionKpi = ({ summary, previousComplete, translate, language }) => {
  const share = summary.headline.conversations_started_with_suggestion_pct;
  const m = summary.series.metrics;
  return {
    key: "started_with_suggestion",
    label: translate("analyticsStartedWithSuggestion"),
    value: share.value === null ? translate("analyticsNotAvailable") : formatPercent(share.value, language),
    change: previousComplete ? variation({ kind: "percent", ...share }, language) : NO_COMPARISON,
    spark: [
      percentOf(m.conversations_started_with_suggestion.current, m.conversations_started.current),
      percentOf(m.conversations_started_with_suggestion.previous, m.conversations_started.previous),
    ],
    context: countText(summary.sources.first_source.values.quick_reply || 0, "analyticsKpiConversationCount", translate, language),
  };
};
